var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaraTriste(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono-2@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "9.82%",
    y1: "82.5%",
    x2: "83.95%",
    y2: "22.54%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-26.1413844%",
    y1: "94.1825107%",
    x2: "155.841924%",
    y2: "3.92072739%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-346.637427%",
    y1: "370.833333%",
    x2: "195.321637%",
    y2: "-67.4707602%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-243.421053%",
    y1: "287.280702%",
    x2: "298.538012%",
    y2: "-151.023392%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementos-/-icono-2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,82 C18.3563253,82 0,63.6436747 0,41 C0,18.3563253 18.3563253,0 41,0 C63.6436747,0 82,18.3563253 82,41 C81.9728898,63.6324358 63.6324358,81.9728898 41,82 Z M41,5.6744 C21.4902098,5.6744 5.6744,21.4902098 5.6744,41 C5.6744,60.5097902 21.4902098,76.3256 41,76.3256 C60.5097902,76.3256 76.3256,60.5097902 76.3256,41 C76.3030065,21.499576 60.500424,5.69699349 41,5.6744 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4675994,43 C50.5913325,43.0090282 57.9866068,50.4888062 58,59.7213115 C58,61.5320811 56.5493762,63 54.7599411,63 C52.970506,63 51.5198822,61.5320811 51.5198822,59.7213115 C51.5198821,54.1215063 47.033828,49.5819674 41.5,49.5819674 C35.966172,49.5819674 31.4801179,54.1215063 31.4801178,59.7213115 C31.4801178,61.5320811 30.029494,63 28.2400589,63 C26.4506238,63 25,61.5320811 25,59.7213115 C25.0132516,50.514316 32.3691804,43.0450563 41.4675994,43 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-3)",
    cx: 50.5,
    cy: 28.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-4)",
    cx: 31.5,
    cy: 28.5,
    r: 5.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaraTriste);
export default __webpack_public_path__ + "static/media/cara-triste.5e7f938b1a0440b771af030dbbfc4ac2.svg";
export { ForwardRef as ReactComponent };